<ion-header>
  <ion-toolbar>
    <ion-title>Move article to...</ion-title>
    <ion-buttons slot="end">
      <!-- Use standard cancel pattern -->
      <ion-button (click)="cancel()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <!-- Use ionInput for debounced changes -->
    <ion-searchbar
      [(ngModel)]="searchTerm"
      (ionInput)="onSearchInput()"
      placeholder="Search collections..."
      debounce="300"
      showClearButton="always"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- Wrap the list content in a radio group and bind its value -->
  <ion-radio-group [value]="selectedId">
    <ion-list lines="none">
      <!-- Remove lines for cleaner tree -->

      <!-- Root Option -->
      <ion-item
        button
        detail="false"
        (click)="selectCollection(rootOption.id)"
        class="collection-item"
        [class.selected-node]="selectedId === rootOption.id"
      >
        <ion-icon name="library-outline" slot="start" class="collection-icon" aria-hidden="true"></ion-icon>
        <ion-label>{{ rootOption.name }}</ion-label>
        <!-- Remove [checked], value is handled by group -->
        <ion-radio slot="end" [value]="rootOption.id" aria-label="Select root Knowledge Base"></ion-radio>
      </ion-item>

      <!-- Loading Indicator -->
      <ion-item *ngIf="isLoading">
        <ion-spinner name="dots" slot="start"></ion-spinner>
        <ion-label>Loading Collections...</ion-label>
      </ion-item>

      <!-- Empty States -->
      <ion-item *ngIf="!isLoading && collectionTree.length === 0 && !searchTerm" lines="none">
        <ion-label class="ion-text-center ion-padding-vertical empty-state-label"
          >No collections have been created yet.</ion-label
        >
        <!-- Optional: Add button to create first collection -->
        <!--
        <ion-button fill="clear" size="small" (click)="addNewCollection(null)">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>
          Create Collection
        </ion-button>
        -->
      </ion-item>
      <ion-item *ngIf="!isLoading && filteredTree.length === 0 && searchTerm" lines="none">
        <ion-label class="ion-text-center ion-padding-vertical empty-state-label"
          >No collections found matching "{{ searchTerm }}".</ion-label
        >
      </ion-item>

      <!-- Recursive Tree Node Template -->
      <ng-container *ngIf="!isLoading && filteredTree.length > 0">
        <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { nodes: filteredTree }"></ng-container>
      </ng-container>
    </ion-list>
  </ion-radio-group>
  <!-- Close the radio group -->
</ion-content>

<ion-footer>
  <ion-toolbar>
    <!-- Disable button until a selection is made -->
    <ion-button expand="block" color="dark" (click)="confirmSelection()" [disabled]="selectedId === undefined">
      Move Here
    </ion-button>
  </ion-toolbar>
</ion-footer>

<!-- ===================== -->
<!-- Recursive Node Template -->
<!-- ===================== -->
<ng-template #treeNodeTemplate let-nodes="nodes">
  <ng-container *ngFor="let node of nodes">
    <!-- Only render node if it matches filter (or search is empty) -->
    <!-- This check might be redundant if filteredTree is used -->
    <!-- ARIA level for accessibility -->
    <ion-item
      *ngIf="node.matchesFilter"
      button
      detail="false"
      (click)="selectCollection(node.id)"
      class="collection-item tree-node-item"
      [class.selected-node]="selectedId === node.id"
      [style]="getIndentStyle(node.level || 0)"
      [attr.aria-level]="(node.level || 0) + 1"
      [attr.aria-expanded]="node.children.length > 0 ? node.expanded : null"
    >
      <!-- Expand/Collapse Icon -->
      <ion-button
        *ngIf="node.children.length > 0"
        fill="clear"
        size="small"
        class="expand-button"
        (click)="toggleExpand(node, $event)"
        [attr.aria-label]="node.expanded ? 'Collapse ' + node.name : 'Expand ' + node.name"
      >
        <ion-icon
          slot="icon-only"
          [name]="node.expanded ? 'chevron-down-outline' : 'chevron-forward-outline'"
          class="expand-icon"
          aria-hidden="true"
        ></ion-icon>
      </ion-button>
      <!-- Indentation Placeholder (if no children) -->
      <span *ngIf="node.children.length === 0" class="indent-placeholder" aria-hidden="true"></span>

      <!-- Folder Icon -->
      <ion-icon name="folder-outline" slot="start" class="collection-icon node-icon" aria-hidden="true"></ion-icon>

      <!-- Node Name (Highlight matching part?) -->
      <ion-label [class.matched-text]="node.nodeDirectlyMatchesFilter && searchTerm.length > 0">{{
        node.name
      }}</ion-label>

      <!-- Selection Radio Button -->
      <!-- Remove [checked], value is handled by group -->
      <ion-radio slot="end" [value]="node.id" [attr.aria-label]="'Select collection ' + node.name"></ion-radio>

      <!-- Optional: Add button per item -->
      <!--
      <ion-buttons slot="end" class="action-buttons">
          <ion-button fill="clear" size="small" (click)="addNewCollection(node.id, $event)">
              <ion-icon slot="icon-only" name="add-outline" aria-label="Add new collection inside this one"></ion-icon>
          </ion-button>
      </ion-buttons>
      -->
    </ion-item>

    <!-- Recursively render children container only if expanded -->
    <div *ngIf="node.expanded && node.children.length > 0" class="child-nodes-container" role="group">
      <ng-container *ngTemplateOutlet="treeNodeTemplate; context: { nodes: node.children }"></ng-container>
      <!-- Optional: Add button within expanded section -->
      <!--
       <ion-item lines="none" [style]="getIndentStyle((node.level || 0) + 1)">
          <ion-button fill="clear" size="small" (click)="addNewCollection(node.id)">
              <ion-icon slot="start" name="add-outline"></ion-icon>
              New collection inside "{{node.name}}"
          </ion-button>
      </ion-item>
        -->
    </div>
  </ng-container>
</ng-template>
